import { CheckSingleIcon } from '@grupoboticario/flora-react-icons';
import { styled, theme } from 'ui/theme';

export const OrderSuccessTitle = {
  Component: styled('div')`
    align-items: center;
    color: ${theme.colors.build.brand1};
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: ${theme.space[2]};
    margin-top: ${theme.space[10]};
  `,

  Icon: styled(CheckSingleIcon)`
    color: ${theme.colors.build.brand2};
    margin-bottom: ${theme.space[6]};
  `,
};
